module.exports = __webpack_public_path__ + "img/broadcast-scene-4.97f9ad52.png";